$(document).ready(function () {
  if (window.innerWidth >= 992) {
    $(".typewriter").each(function() {
      $(this).css('height', $(this).outerHeight());
      new TypeIt('#' + $(this).attr('id') , {
        speed: 30,
        cursorChar: "_",
        lifeLike: false,
        nextStringDelay: 0,
        waitUntilVisible: true,
        afterComplete: function(instance){
          $(instance.element).css('height', 'auto');
          instance.destroy();
        },
      }).go();
    });
  }
});
